import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import { GET_PDP_FROM_THE_COLLECTION } from 'mocks/queries';
import { getProductPrimaryOption, getDefaultOptionData } from 'commons/productUtils';
import convertOptionParamFormat from 'commons/convertOptionParamFormat';
import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import { getConstructedImagesForMaterial } from 'data-hooks/useProductCardMaterialPhotos/utils';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import { getConfigPhotosForSelectedOptions } from 'data-hooks/usePDPPhotos/utils';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import useIsBrowser from 'hooks/useIsBrowser';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import useUserLocation from 'global-state/userLocation/useUserLocation';
import PDPCollectionSliderUI from './PDPCollectionSliderUI';
import { convertOptionsToNewFormat, productHasOption } from './utils';
import usePDPOptions from '../state/context/usePDPOptions';
import usePdpSelectedOptionsVariantSku from '../state/pdpSelectedOptionsVariantSku/usePdpSelectedOptionsVariantSku';
const PDPCollectionSliderInner = t0 => {
  const $ = _c(47);
  const {
    setDisplayPressComp
  } = t0;
  const {
    error,
    data: basicDetails
  } = usePDPBasicDetails();
  const selectedOptionsVariantSku = usePdpSelectedOptionsVariantSku();
  const {
    loading,
    data: t1
  } = usePDPOptions();
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    selectedOptionsExtended,
    upholsteryOptionId
  } = t2;
  const isBrowser = useIsBrowser();
  const isSmallDesktopOnly = useMediaQuery({
    query: "(min-width: 1024px) and (max-width: 1199px)"
  }) && isBrowser;
  let t3;
  if ($[2] !== basicDetails) {
    t3 = basicDetails || {};
    $[2] = basicDetails;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    id,
    meta
  } = t3;
  const userLocation = useUserLocation();
  let t4;
  if ($[4] !== meta?.collectionSlug) {
    t4 = meta?.collectionSlug?.replace("collections/", "");
    $[4] = meta?.collectionSlug;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = isSmallDesktopOnly ? 3 : 4;
  const t6 = userLocation?.stateShortName;
  let t7;
  if ($[6] !== t6) {
    t7 = getVisitorLocationQueryVariables(t6);
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== id || $[9] !== t4 || $[10] !== t5 || $[11] !== t7) {
    t8 = {
      slug: t4,
      offset: 0,
      limit: t5,
      forProduct: id,
      ...t7
    };
    $[8] = id;
    $[9] = t4;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = !id || !meta?.collectionSlug;
  let t10;
  if ($[13] !== t8 || $[14] !== t9) {
    t10 = {
      variables: t8,
      ssr: false,
      skip: t9
    };
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const {
    data: collectionData,
    loading: collectionLoading,
    error: collectionError
  } = useSuspenseQuery(GET_PDP_FROM_THE_COLLECTION, t10);
  const [products, updateProducts] = useState(null);
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = [];
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const [productImgs, updateProductImgs] = useState(t11);
  const [collection, updateCollection] = useState(null);
  const [collectionLink, setCollectionLink] = useState("");
  let t12;
  let t13;
  if ($[17] !== meta || $[18] !== setDisplayPressComp) {
    t12 = () => {
      if (!meta?.id) {
        return;
      }
      if (!meta.collectionSlug) {
        setDisplayPressComp(true);
      }
    };
    t13 = [meta, setDisplayPressComp];
    $[17] = meta;
    $[18] = setDisplayPressComp;
    $[19] = t12;
    $[20] = t13;
  } else {
    t12 = $[19];
    t13 = $[20];
  }
  useEffect(t12, t13);
  let t14;
  if ($[21] !== collection?.slug || $[22] !== collectionData || $[23] !== setDisplayPressComp) {
    t14 = () => {
      if (!collectionData?.collection || !collectionData?.collection?.products || collectionData?.collection?.slug === collection?.slug) {
        return;
      }
      const {
        collection: collectionValue
      } = collectionData;
      updateCollection(collectionValue);
      if (!collectionValue?.products?.length) {
        setDisplayPressComp(true);
        return;
      }
      setCollectionLink(collectionValue.name);
      const finalProducts = [];
      collectionValue.products.forEach(prod => {
        const finalOptions = prod.options?.length ? convertOptionsToNewFormat(prod.options) : [];
        const urlVal = prod.attributes.filter(_temp);
        const primaryOption = getProductPrimaryOption(finalOptions);
        const defaultOptionData = getDefaultOptionData(finalOptions);
        const defaultOptionImgs = defaultOptionData?.optionData ? getConstructedImagesForMaterial({
          product: prod,
          options: finalOptions,
          forMaterial: defaultOptionData.optionName,
          forMaterialType: defaultOptionData.optionData.name
        }) : {};
        finalProducts.push({
          ...prod,
          url: urlVal?.[0]?.value || "",
          options: finalOptions,
          primaryOptionName: primaryOption?.name || "",
          primaryOptionId: primaryOption?.id || null,
          defaultImage: {
            ...(defaultOptionImgs || {})
          }
        });
      });
      updateProducts(finalProducts);
    };
    $[21] = collection?.slug;
    $[22] = collectionData;
    $[23] = setDisplayPressComp;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  const t15 = collection?.slug;
  let t16;
  if ($[25] !== collectionData || $[26] !== setDisplayPressComp || $[27] !== t15) {
    t16 = [t15, collectionData, setDisplayPressComp];
    $[25] = collectionData;
    $[26] = setDisplayPressComp;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  useEffect(t14, t16);
  let t17;
  if ($[29] !== collection || $[30] !== products || $[31] !== selectedOptionsExtended || $[32] !== selectedOptionsVariantSku || $[33] !== upholsteryOptionId) {
    t17 = () => {
      const setProductImgs = () => {
        if (!products?.length) {
          return;
        }
        let newCollectionLink = "";
        const updatedImgs = [];
        products.forEach(prod_0 => {
          const imgs = getConfigPhotosForSelectedOptions(selectedOptionsVariantSku, selectedOptionsExtended, upholsteryOptionId, prod_0);
          const hasSelection = prod_0.primaryOptionId && selectedOptionsExtended?.[prod_0.primaryOptionId]?.value ? productHasOption(prod_0.options, selectedOptionsExtended[prod_0.primaryOptionId].value.id, prod_0.primaryOptionId) : false;
          if (hasSelection && !newCollectionLink) {
            const optQSValues = convertOptionParamFormat(prod_0.primaryOptionName, selectedOptionsExtended[prod_0.primaryOptionId].value.value, "qs");
            newCollectionLink = optQSValues.finalOptionName && optQSValues.finalOptionValue ? `/?optionName=${optQSValues.finalOptionName}&optionValue=${optQSValues.finalOptionValue}` : "";
            if (newCollectionLink) {
              setCollectionLink(collection.slug + newCollectionLink);
            }
          }
          const selectionQS = hasSelection ? `?${prod_0.primaryOptionName.toLowerCase()}=${selectedOptionsExtended[prod_0.primaryOptionId].value.value.toLowerCase().split(" ").join("-")}` : "";
          if (imgs?.length && hasSelection) {
            updatedImgs.push({
              ...imgs[0],
              url: prod_0.url + selectionQS
            });
          } else {
            const finalSrc = prod_0.defaultImage ? prod_0.primaryOptionId ? prod_0.defaultImage.transparent_config_image : prod_0.defaultImage.transparent_hero_image : "";
            updatedImgs.push({
              id: 1,
              src: finalSrc,
              url: prod_0.url
            });
          }
        });
        updateProductImgs(updatedImgs);
      };
      if (!products?.length) {
        return;
      }
      setProductImgs();
    };
    $[29] = collection;
    $[30] = products;
    $[31] = selectedOptionsExtended;
    $[32] = selectedOptionsVariantSku;
    $[33] = upholsteryOptionId;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  const t18 = collection?.slug;
  let t19;
  if ($[35] !== products || $[36] !== selectedOptionsExtended || $[37] !== selectedOptionsVariantSku || $[38] !== t18 || $[39] !== upholsteryOptionId) {
    t19 = [t18, products, selectedOptionsVariantSku, selectedOptionsExtended, upholsteryOptionId];
    $[35] = products;
    $[36] = selectedOptionsExtended;
    $[37] = selectedOptionsVariantSku;
    $[38] = t18;
    $[39] = upholsteryOptionId;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  useEffect(t17, t19);
  if (error || collectionError || !id) {
    let t20;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = <div className="PDPCollectionSlider__filler" />;
      $[41] = t20;
    } else {
      t20 = $[41];
    }
    return t20;
  }
  const t20 = collectionLoading || loading;
  const t21 = collection?.name;
  let t22;
  if ($[42] !== collectionLink || $[43] !== productImgs || $[44] !== t20 || $[45] !== t21) {
    t22 = <PDPCollectionSliderUI productImgs={productImgs} loading={t20} collectionSlug={t21} collectionLink={collectionLink} />;
    $[42] = collectionLink;
    $[43] = productImgs;
    $[44] = t20;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  return t22;
};
PDPCollectionSliderInner.propTypes = {
  setDisplayPressComp: PropTypes.func
};
const PDPCollectionSlider = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SuspenseWithLoader><PDPCollectionSliderInner {...props} /></SuspenseWithLoader>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default withBrowserOnly(PDPCollectionSlider);
function _temp(attr) {
  return attr.code === "url_key";
}